import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useConsumerContext} from "../../context/ConsumerContext";
import addressData from "../../data/addressData.json";
import {AVAILABLE_ACTIONS} from "../../utils/constants";
import {Box, Grid, MenuItem, Typography} from "@material-ui/core";
import * as yup from "yup";
import {MUICardWithControl, MUISelect, MUISwitch} from "../../utils/formUtils";
import {WizardNav} from "../../utils/fmapUtils";
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import PestControlRoundedIcon from '@mui/icons-material/PestControlRounded';
import AgricultureRoundedIcon from '@mui/icons-material/AgricultureRounded';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';

const validationSchema = yup.object().shape({
    businessType: yup.string().when('isBusinessLocation', {
        is: (isBusinessLocation) => isBusinessLocation === true,
        then: yup.string().required('Please complete all required fields').notOneOf(['none'],'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    })
})
export default function Pets() {

    const {handleSubmit, control, trigger, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});
    const {consumerData, dispatch} = useConsumerContext();

    // loading static data when component loads
    useEffect(() => {
        // Anything in here is fired on component mount.
        // fetching static data
        setBusinessTypeList(addressData.businessType);
    }, []);

    const [businessTypeList, setBusinessTypeList] = useState([]);

    // updating the state as the user types...
    const handleFormChange = (event) => {
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_PETS, userRequest: {[event.target.name]: event.target.value}});
    };

    const handleFormChangeCheckbox = (event) => {
        dispatch({
            type: AVAILABLE_ACTIONS.UPDATE_PETS,
            userRequest: {[event.target.name]: event.target.checked}
        });
    };

    const onSubmit = (data) => {
        conditionalCheckForBusinessLocation(data);
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_PETS, userRequest: data});
        dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: consumerData.wizardStep + 1});
    };

    const handleBackClick = async () => {
        conditionalCheckForBusinessLocation();
        const isValid = await trigger(['businessType']);
        if (isValid) {
            dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: consumerData.wizardStep - 1});
        }
    }

    function conditionalCheckForBusinessLocation(data) {
        if (consumerData?.isBusinessLocation === false) {
            if (data) {
                data.businessType = undefined;
            } else {
                dispatch({type: AVAILABLE_ACTIONS.UPDATE_PETS, userRequest: {"businessType": undefined}});
            }

        }
    }

    return (
        <section>
            <Box m={2} marginBottom={0}>
                <Typography variant="h4" align="left" component="h4" gutterBottom
                            style={{paddingLeft: 24, fontWeight: 600}}>
                    Pets (Optional)
                </Typography>
            </Box>
            <form
                onSubmit={handleSubmit(onSubmit)}>
                <Box m={3} marginTop={0}>
                    <Grid container alignItems="flex-start" spacing={2} style={{paddingLeft: 8, paddingTop: 8}}>
                        <Grid item xs={12} sm={8} md={6}>
                            <MUICardWithControl
                                label="Is any business or farming conducted on site? (e.g. boarding of animals, carpentry, hair salon, mechanic, daycare, etc.)"
                                children={
                                    <MUISwitch errors={errors} defaultValue={consumerData?.isBusinessLocation}
                                               value={consumerData?.isBusinessLocation} name="isBusinessLocation"
                                               control={control} onChecked={handleFormChangeCheckbox}/>
                                }
                                icon={<BusinessCenterRoundedIcon style={{
                                    backgroundColor: '#3f51b5',
                                    padding: 16,
                                    fontSize: 16,
                                    height: 64,
                                    width: 64,
                                    marginBottom: 16,
                                    color: '#ffffff',
                                    borderRadius: 20
                                }}/>}/>

                        </Grid>
                        {consumerData?.isBusinessLocation && <Grid item xs={12} sm={8} md={6}>
                            <MUICardWithControl label="What is the description of the business?" children={
                                <MUISelect id="businessType" control={control} name="businessType"
                                           errors={errors}
                                           defaultValue={consumerData?.businessType}
                                           value={consumerData?.businessType} onFormChange={handleFormChange}>
                                    <MenuItem key="none" value="none" disabled>--Select--</MenuItem>
                                    {businessTypeList.map(type => {
                                        return <MenuItem key={type?.value} value={type?.value}>{type?.label}</MenuItem>
                                    })}
                                </MUISelect>
                            } icon={<AgricultureRoundedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                        </Grid>}
                        <Grid item xs={12} sm={8} md={6}>
                            <MUICardWithControl label="Do you own any exotic animals?" children={
                                <MUISwitch errors={errors} defaultValue={consumerData?.ownExoticAnimals}
                                           value={consumerData?.ownExoticAnimals} name="ownExoticAnimals"
                                           control={control} onChecked={handleFormChangeCheckbox}/>
                            } icon={<PestControlRoundedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                        </Grid>

                        <Grid item xs={12} sm={8} md={6}>
                            <MUICardWithControl
                                label="Do you own any dogs that are part of the following breed list: Akita, Alaskan Malamute, American Staffordshire Terrier, Bullmastiff, Chow Chow, Doberman Pinscher, German Shepherd, Great Dane, Pit Bull, Perro de Presa Canario, Rottweiler, Siberian Husky, Staffordshire Bull Terrier, any wolf hybrid or any mix of these breeds"
                                children={
                                    <MUISwitch errors={errors} defaultValue={consumerData?.isDogBreedAmongListed}
                                               value={consumerData?.isDogBreedAmongListed} name="isDogBreedAmongListed"
                                               control={control} onChecked={handleFormChangeCheckbox}/>
                                } icon={<PetsOutlinedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                        </Grid>
                    </Grid>
                </Box>
                <WizardNav handleBackClick={handleBackClick} currentStep={consumerData?.wizardStep}/>
            </form>
        </section>
    );
}
